import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Modal as MuiModal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Modal({ message, open, setShowModal }) {
  let sm = useMediaQuery("(max-width:500px)");

  const navigate = useNavigate();
  const handleClose = () => setShowModal(false);
  const handleYes = () => {
    navigate(-1);
  };

  return (
    <div>
      <MuiModal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: sm? 300 : 400,
            height: 100,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="body1" component="h3">
            {message}
          </Typography>
          <div style={{ position: "absolute", right: "20px", bottom: "10px" }}>
            <Button
              variant="contained"
              sx={{ marginRight: "20px" }}
              onClick={handleClose}
            >
              No
            </Button>
            <Button variant="text" onClick={handleYes}>
              Yes
            </Button>
          </div>
        </Box>
      </MuiModal>
    </div>
  );
}
